import { useState, useEffect, useCallback } from "react";
import { decryptData, defaulUrl } from "./const";
import Swal from "sweetalert2";
const UseFetch = (url) => {
    const [data, setData] = useState(null);
    const [isloading, setIsloading] = useState(true);
    let status = 0;
    const [error, setErrorMessage] = useState(null);
    const [refreshIndex, setRefreshIndex] = useState(0); // utilisé pour forcer le useEffect
    const token = decryptData('ACCESS_TOKEN');

    const fetchData = useCallback(async () => {
        setIsloading(true);
        try {

            const response = await fetch(`${defaulUrl}${url}`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            const da = await response.json();
            if (!response.ok) throw new Error("Erreur API " + da?.message);
            setData(da);
            setErrorMessage(null);
        } catch (err) {
            setErrorMessage("Serveur non disponible");
            console.log(err);
            Swal.fire("Erreur de chargement", err.message, 'error')

        } finally {
            setIsloading(false);
        }
    }, [url, token, refreshIndex]);


    useEffect(() => {
        fetchData();
    }, [url, refreshIndex]);

    const refresh = () => {
        setRefreshIndex(prev => prev + 1);
    };

    return { data, isloading, error, refresh };
}


export default UseFetch;